//{{-- This is used in create.blade.php and clientprojects.blade --}}

//{{-- ========================================================================================== --}}
//{{-- Script to inject the HTML code for the datatable in a given div                            --}}
//{{-- ========================================================================================== --}}
 window.injectTableDiv = function(targetdiv, readonly) {      
    validatediv = '<div id="validateMsg-div" class="col text-danger" style="display: none"> ' +
                        '<strong> ' + ddt_files_incomplete_edit + '</strong> ' +
                        '</div> ';
    //{{-- Note that when doc datatable is shown WITHOUT the change and delete columns at the end, it DOES HAVE STATUS --}}
    tableDivWithoutChgDel = '<div class="my-semiopaque-bg p-2 m-0"> ' +
                    '<table id="filegrid" class="bg-white text-left table table-bordered nowrap" style="width:100%"> ' +
                        '<thead class="text-secondary"> ' +
                            '<tr> ' +
                                '<th>' + ddt_original_file + '</th> ' +
                                '<th>' + ddt_final_file    + '</th> ' +
                                '<th>' + ddt_file_type     + '</th> ' +
                                '<th>' + ddt_minutes_upper + '</th> ' +
                                '<th>' + ddt_from_lang     + '</th> ' +
                                '<th>' + ddt_to_language   + '</th> ' +
                                '<th>' + ddt_status        + '</th> ' +
                                '<th>' + ddt_characters    + '</th> ' +
                                '<th>' + ddt_words         + '</th> ' +
                                '<th>' + ddt_service       + '</th> ' +
                                '<th>' + ddt_due_date      + '</th> ' +
                                '<th>' + ddt_price         + '</th> ' +
                            '</tr> ' +
                        '</thead> ' +
                        '<tbody class="text-dark"> ' +
                            '<tr> ' +
                                '<td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td> ' +
                            '</tr> ' +
                        '</tbody> ' +
                    '</table> ' +
                    '<div class="m-0 p-0" style="text-align:right; font-size:.8em">(*) ' + ddt_tbc + '</div>' + 
                '</div> ';
    //{{-- Note that when doc datatable is shown WITH the change and delete columns at the end, it HAS NO STATUS --}}
    tableDivWithChgDel = '<div class="my-semiopaque-bg p-2 m-0"> ' +
                    '<table id="filegrid" class="bg-white text-left table table-bordered nowrap" style="width:100%"> ' +
                        '<thead class="text-secondary"> ' +
                            '<tr> ' +
                                '<th>' + ddt_original_file + '</th> ' +
                                '<th>' + ddt_final_file    + '</th> ' +
                                '<th>' + ddt_file_type     + '</th> ' +
                                '<th>' + ddt_minutes_upper + '</th> ' +
                                '<th>' + ddt_from_lang     + '</th> ' +
                                '<th>' + ddt_to_language   + '</th> ' +
                                '<th>' + ddt_characters    + '</th> ' +
                                '<th>' + ddt_words         + '</th> ' +
                                '<th>' + ddt_service       + '</th> ' +
                                '<th>' + ddt_due_date      + '</th> ' +
                                '<th>' + ddt_price         + '</th> ' +
                                '<th></th> ' +
                                '<th></th> ' +
                            '</tr> ' +
                        '</thead> ' +
                        '<tbody class="text-dark"> ' +
                            '<tr> ' +
                                '<td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td><td></td> ' +
                            '</tr> ' +
                        '</tbody> ' +
                    '</table> ' +
                '</div> ';
    if (readonly) {
        tablediv = tableDivWithoutChgDel;
    } else {
        tablediv = tableDivWithChgDel;
    }
    tablediv = validatediv + tablediv;
    targetdiv.html(tablediv);
}

//{{-- ========================================================================================== --}}
//{{-- Scripts to handle the files datatable                                                      --}}
//{{-- ========================================================================================== --}}

var descrList = [];
var docDT = null;

$(function(){            
    //{{-- Get Field description constants from database when page loads - This is an AJAX call, so it's asynch ! --}}
    $.get('/getDocDescriptions', function(constants){
        descrList = constants;
    });
});

//{{-- Get ready to recalculate the datatable columns if the window is resized --}}
var resizeMillis = 0;
$(window).on('resize',function(){
    try {
        if (isThere(docDT)) {
            if (Date.now() - resizeMillis > 100) {
                resizeMillis = Date.now();
                docDT.responsive.recalc().columns.adjust();
            }
        }
    } catch (err) {}
});
    
//{{-- This is called after a new file is saved into docArr, so we can do some synching --}}
//{{-- Refreshes the datatable - if it's the first time, creates the datatable by calling loadDocDatatable() --}}
window.docDataTableRefresh = function(targetdiv, docArr, readonly) { 
    weHaveMinutes   = docArr.some(function(doc) {return doc["doctype"] >= 7});     //{{-- controls visibility of the minutes column on the datatable --}}
    needToValidate  = docArr.some(function(doc) {return !doc["validated"]});       //{{-- if we're in clientprojects.blade, all records retrieved from database will be validated --}}
    weHaveFinalFile = docArr.some(function(doc) {return doc["final_path"]});       //{{-- controls visibility of the final file column on the datatable --}}            
    //{{-- Inject the table HTML --}}
    injectTableDiv(targetdiv, readonly);
    //{{-- Load the data table --}}
    docDT = loadDocDatatable(docArr, readonly);    
    //{{-- If the table has files with incomplete data, show the validate message  --}}
    if (readonly && needToValidate) {
        $('[id="validateMsg-div"]').show();  
    }else {
        $('[id="validateMsg-div"]').hide();  
    }            
    //{{-- This is important... --}}
    //{{-- Recalc column widths so the table remains responsive (the $('[id="docDatatable-div"]') is already visible...) --}}
    //{{-- Alternatively, could also do the same for all dataTables, with $($.fn.dataTable.tables(true)).DataTable().columns.adjust().responsive.recalc();  --}}
    docDT.responsive.recalc().columns.adjust();
    docDT.columns().visible(true);
    docDT.columns(3).visible(weHaveMinutes);
    docDT.columns(1).visible(weHaveFinalFile);
    //{{-- Create 3-state sort for the columns - sortDatatable is in my.main.scripts.js --}}
    $('#filegrid').safeOn('order.dt', function() { 
        sortDatatable("filegrid", docDT);
    });
};

//{{-- Initialize the files datatable --}}
//{{-- This loads data from docArr into the table --}}
window.loadDocDatatable = function(docArr, readonly) {
    //{{-- Must have one targets-data-render line for each column on the table  --}}
    coldefsArr = [   
            { responsivePriority: 1, targets: 0,  visible: false, data: "filename",    render:  function (data, type, row, meta) { return fileNameFormat(row, data, readonly); } },
            { responsivePriority: 1, targets: 1,  visible: false, data: "final_path",  render:  function (data, type, row, meta) { return finalPathFormat(row, data); } },
            { responsivePriority: 8, targets: 2,  visible: false, data: "doctype",     render:  function (data, type, row, meta) { return (data != "" && data>=0) ? descrList['docTypeList'][data] : ""; } },
            { responsivePriority: 9, targets: 3,  visible: false, data: "minutes"},
            { responsivePriority: 6, targets: 4,  visible: false, data: "langfrom",    render:  function (data, type, row, meta) {return (data != "" && data>=0) ? descrList['langList'][data] : ""; } },
            { responsivePriority: 3, targets: 5,  visible: false, data: "langto",      render:  function (data, type, row, meta) { return langToFormat(row); } },
        ];
    if (readonly) {
        coldefsArr.push(
            { responsivePriority: 8, targets: 6,  visible: false, data: "docstatus_id",render:  function (data, type, row, meta) { return descrList['docStatusList'][data]; } },
            { responsivePriority: 7, targets: 7,  visible: false, data: "characters"},
            { responsivePriority: 7, targets: 8,  visible: false, data: "words"},
            { responsivePriority: 5, targets: 9,  visible: false, data: "jobtype",     render:  function (data, type, row, meta) { return serviceFormat(row); } },
            { responsivePriority: 4, targets: 10, visible: false, data: "duedate",     render:  function (data, type, row, meta) { return dateTimeFormat(row); } },
            { responsivePriority: 2, targets: 11, visible: false, data: "tier",        render:  function (data, type, row, meta) { return tierPriceFormat(row); } }
        );
    } else {
        coldefsArr.push(
            { responsivePriority: 7, targets: 6,  visible: false, data: "characters"},
            { responsivePriority: 7, targets: 7,  visible: false, data: "words"},
            { responsivePriority: 5, targets: 8,  visible: false, data: "jobtype",     render:  function (data, type, row, meta) { return serviceFormat(row); } },
            { responsivePriority: 4, targets: 9,  visible: false, data: "duedate",     render:  function (data, type, row, meta) { return dateTimeFormat(row); } },
            { responsivePriority: 2, targets: 10, visible: false, data: "tier",        render:  function (data, type, row, meta) { return tierPriceFormat(row); } },
            { responsivePriority: 1, targets: 11, visible: false, data: "", defaultContent: "",     render:  function (data, type, row, meta) { return fileEditButton(row, docArr); } },
            { responsivePriority: 1, targets: 12, visible: false, data: "", defaultContent: "",     render:  function (data, type, row, meta) { return fileDeleteButton(row); } }
        );
    }

    return $('#filegrid').DataTable( {  
        data: docArr,
        destroy: true,                                                              //{{-- destroy is so we don't need to add/delete rows individually... only works for small datasets... --}}
        autoWidth: false,
        responsive: true,
        searching: false, paging: false, info: false,
        order: [],
        columnDefs: coldefsArr,
        createdRow: function(row, data, dataIndex) { setRowBg(row, data, dataIndex) }, 
    });
} 

//{{-- This makes sure the name field isn't too wide - and readies the link for downloading --}}
window.fileNameFormat = function( row, data, readonly ) {
    if (readonly) {
        //{{-- The div for the download link must have an id of 'download' and a name = file name --}}
        fileStr = "/download/" + $("#user_id").val() + "/" + row["doc_id"] + "/original";
        fileNameFormatted = "<div class='p-0 m-0' id='download' name='" + data + "' style='white-space:normal; width:100%; min-width:125px;'>" + "<a href='" + fileStr + "'>'" + data.replace(/_/g, " ") + "</a>" + "</div>";
    } else {
        fileNameFormatted = "<div class='p-0 m-0' style='white-space:normal; width:100%; min-width:125px;'>" + data.replace(/_/g, " ") + "</div>";                
    }
    return fileNameFormatted;
}

//{{-- This puts the final path into a link --}}
window.finalPathFormat = function( row, data ) {
    filePath = "";
    if (row['docstatus_id'] == 40) {
        fileStr = "/download/" + $("#user_id").val() + "/" + row["doc_id"] + "/final";
        filePath = "<div class='p-0 m-0' id='download' name='" + data + "'><a href='" + fileStr + "'>" + ddt_download_upper + "</a></div>";   
    }
    return filePath;
}        

window.setRowBg = function( row, data, dataIndex ) {
    //{{-- first, set background for odd or even rows --}}
    if (dataIndex % 2 == 0) {
        $(row).addClass("my-evenrow-tr-bg");
    } else {
        $(row).addClass("my-oddrow-tr-bg");
    }
    //{{-- then check if it's a "warning" row with unvalidated data --}}
    if (!data.validated) {
        $(row).addClass("my-warning-tr-bg"); 
    }
}

//{{-- This takes the langto array in the form [0,1,2...] and returns a string with "English, French, Italian..." --}}
//{{-- The language names come from the descrList constant, which is loaded from the database on document load --}}
window.langToFormat = function( row ) { 
    //{{-- row has the entire docArr item defining a single row, e.g.: {"filenbr":1,"filename":"test","jobtype":"","doctype":"","characters":"","words":"","videotype":"","minutes":"","langfrom":"","langto":[],"tier":"","tierTotalPrices":[]} --}}
    var lang = "";            
    $.each(row["langto"], function (index, value) {
        lang = lang + ", " + descrList['langList'][value];
    });
    if (lang) lang = lang.substring(2);
    return lang;
}        

//{{-- This returns a string describing the service to be performed on a file > Translation/Revision for doctypes < 7 and Subtitle/Transcription for doctypes >=7 --}}
//{{-- The service names come from the descrList constant, which is loaded from the database on document load --}}
window.serviceFormat = function( row ) { 
    //{{-- row has the entire docArr item defining a single row, e.g.: {"filenbr":1,"filename":"test","jobtype":"","doctype":"","characters":"","words":"","videotype":"","minutes":"","langfrom":"","langto":[],"tier":"","tierTotalPrices":[]}  --}}
    var translation = descrList['jobTypeList'][1];
    var revision = descrList['jobTypeList'][2];
    var jobtype = "";
    if (row['doctype'] < 7) {
        if (row['langto'].length > 0) {
            //{{-- We have a text document, see if any one of langto = langfrom (a revision) --}}
            jobtype = (row['langto'].indexOf(row['langfrom']) > -1) ? revision : translation;
            //{{-- If there are other languages, we must add "Translation" as well --}}
            if (row['langto'].length > 1 && jobtype == revision) jobtype = translation + "/" + revision;
        }
    } else {
        //{{-- We have a video/audio file --}}
        jobtype = descrList['videoTypeList'][row['videotype']];
    }            
    return jobtype;
}           

//{{-- This takes the datatable row and uses the chosen tier value to return the right price --}}
window.tierPriceFormat = function( row ) { 
    //{{-- row has the entire docArr item defining a single row, e.g.: {"filenbr":1,"filename":"test","jobtype":"","doctype":"","characters":"","words":"","videotype":"","minutes":"","langfrom":"","langto":[],"tier":"","tierTotalPrices":[]} --}}
    var price = row['tierTotalPrices'][row['tier']];
    var sitePrice = (row['tierTotalSitePrices'] ? row['tierTotalSitePrices'][row['tier']] : null);
    var pprice = "";
    var asterisk = "";
    if (!price && sitePrice) {
        price = sitePrice;
        asterisk = ' (*)';
    }
    if (price) pprice = glb_usr_currency_symbol + " " + price.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,') + asterisk;
    return pprice;
}   

//{{-- This takes the datatable row and returns a due date+time string properly formatted --}}
window.dateTimeFormat = function( row ) { 
    //{{-- row has the entire docArr item defining a single row, e.g.: {"filenbr":1,"filename":"test","jobtype":"","doctype":"","characters":"","words":"","videotype":"","minutes":"","langfrom":"","langto":[],"tier":"","tierTotalPrices":[]} --}}
    var datetime = '';
    var dt = '';
    if (row['duedate']) {
        dt = 'd';
        datetime = row['duedate'];
        if (row['duetime']) {
            dt = 'dt';
            datetime = datetime + " " + row['duetime'];
        }
    }
    if (datetime.length > 0) {
        datetime = formatDateTime(datetime, dt, true )
    }
    return datetime;
}          

//{{-- This returns the fileEditIcon to place on the grid, sets its id to the fileNbr of the row --}}
window.fileEditButton = function( row, data ) { 
    //{{-- row has the entire docArr item defining a single row, e.g.: {"filenbr":1,"filename":"test","jobtype":"","doctype":"","characters":"","words":"","videotype":"","minutes":"","langfrom":"","langto":[],"tier":"","tierTotalPrices":[]} --}}
    //{{-- Edit icon will pulsate only for non-validated rows --}}
    var index = myFindIndex(data, "filenbr", row['filenbr']); //{{-- IE doesn't support array.findIndex, so we implement our own - in main.blade --}}
    if (index > -1 && data[index].validated) {
        editIcon =  '<img src="' + ddt_iconEdit + '" title="Edit" style="cursor:pointer" onclick="event.stopPropagation(); fileEditIconClick(' +  row["filenbr"] + ')" >'
    } else {
        editIcon =  '<img src="' + ddt_iconEdit + '" title="Edit" class="icon_pulse" style="cursor:pointer" onclick="event.stopPropagation(); fileEditIconClick(' +  row["filenbr"] + ')" >'
    }
    return editIcon;
}

//{{-- This returns the fileDeleteIcon to place on the grid, sets its id to the fileNbr of the row --}}
window.fileDeleteButton = function( row ) { 
    //{{-- row has the entire docArr item defining a single row, e.g.: {"filenbr":1,"filename":"test","jobtype":"","doctype":"","characters":"","words":"","videotype":"","minutes":"","langfrom":"","langto":[],"tier":"","tierTotalPrices":[]} --}}
    return '<img src="' + ddt_iconDelete + '" title="Delete" style="cursor:pointer" onclick="event.stopPropagation(); fileDeleteIconClick(' +  row["filenbr"] + ')" >'
} 
  
//{{-- ========================================================================================== --}}
//{{-- Scripts to process clicks on the Edit and Delete icons                                     --}}
//{{-- ========================================================================================== --}}

window.fileEditIconClick = function(fileNbr) {        
    fileEditCallback(fileNbr);                                      //{{-- Callback in create.blade --}}
};
window.fileDeleteIconClick = function(fileNbr) {        
    fileDeleteCallback(fileNbr);                                    //{{-- Callback in create.blade --}}
};        
